module.exports = __webpack_public_path__ + "static/media/Agro-dealer infographic - Desktop - 09-05-2024 C.1ccb3e4f.gif";